// packages/content/src/tuning/dev.ts (M2-T12, rev 5 item 18) — read only by DEV_MODE routes; numbers live in content even for dev-only routes
import type { TuningBank } from '../schema/tuning';
export default { maxGrantBells: 10_000_000 } as const satisfies TuningBank;
